import strings from 'owa-strings/owa-calendar-strings';
import { ControlIcons } from 'owa-control-icons';
import { lazyShowCalendarNotificationWithButtonCallback } from 'owa-calendar-notification-bar';
import { orchestrator } from 'satcheljs';
import { reloadItemsCache } from '../utils/SharedCacheFunctions';
import { updatingCalendarEventFailed } from '../actions/publicActions';

orchestrator(updatingCalendarEventFailed, actionMessage => {
    const { eventBeforeUpdate, errorMessage, allowLocalUpdate, retryFunction } = actionMessage;

    if (allowLocalUpdate) {
        reloadItemsCache(eventBeforeUpdate.ParentFolderId.Id);
    }

    lazyShowCalendarNotificationWithButtonCallback
        .import()
        .then(showCalendarNotificationWithButtonCallback => {
            showCalendarNotificationWithButtonCallback(
                'updateCalendarEventFailed',
                errorMessage,
                strings.tryAgainLabel,
                () => retryFunction(),
                ControlIcons.Error
            );
        });
});
